import React, { FC, ReactNode } from "react";
import SpinnerView from "@app/components/spinnerView/spinnerView";
import { usePatientEducation } from "@app/provider";
import ErrorPage from "./error";

interface PatientEducationLoaderProps {
  children: ReactNode;
}

export const PatientEducationLoader: FC<PatientEducationLoaderProps> = ({
  children,
}) => {
  const { clinic, loading, error } = usePatientEducation();

  // useLazyQuery stays loading:false until its effect fires, so a null clinic is not a failed lookup yet.
  if (loading || (!error && !clinic)) {
    return <SpinnerView isLoading={true} />;
  }

  if (error) {
    return <ErrorPage />;
  }

  // Success - render children
  return <>{children}</>;
};
